import React, { useEffect, useState } from "react";
import styled from "styled-components";
import UserIdenticon from "../../commons/UserIdenticon";
import { getEllipsisTxt, getSliceLongTxt } from "../../../helpers/formatters";
import axios from "axios";
import { Link } from "@reach/router";
import { getFileTypeFromURI } from '../../../helpers/fileTypeDecoder'
import { useMoralis } from 'react-moralis';

const Outer = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
`;

export default function SellNFTContainer(props) {
  const { data, sellerProfile, walletAddress } = props;
  const [nftImage, setNftImage] = useState("");
  const [nftTitle, setNftTitle] = useState("~");
  const [isNftImageLoading, setIsNftImageLoading] = useState(false)
  const [nftContentType, setNftContentType] = useState('')
  const [isLoadingProfile, setIsLoadingProfile] = useState(false)
  const [profileData, setProfileData] = useState({})
  const { Moralis, isInitialized } = useMoralis()

  const getUserImage = (moralisAttributes, imageSize = 50) => {

    if (moralisAttributes) {
      if ("profileImageCID" in moralisAttributes && moralisAttributes.profileImageCID != null) {
        const profileImageUrl = `https://hodl4gold.mypinata.cloud/ipfs/${moralisAttributes.profileImageCID}`
        return <img className="profile-image" src={profileImageUrl} alt="" />
      } else {
        return (
          <UserIdenticon
            size={imageSize}
            walletAddress={moralisAttributes.walletAddress}
            customCss={{ width: "50px", height: "50px" }}
          />
        );
      }
    } else {
      return (
        <UserIdenticon
          size={imageSize}
          walletAddress={walletAddress}
          customCss={{ width: "50px", height: "50px" }}
        />
      );
    }
  };

  const getUsername = (moralisAttributes) => {
    if (moralisAttributes) {
      if ("username" in moralisAttributes && moralisAttributes.username !== "") {
        return getSliceLongTxt(moralisAttributes.username, 40)
      } else {
        return getEllipsisTxt(moralisAttributes ? moralisAttributes.walletAddress : '', 7)
      }
    } else {
      return getEllipsisTxt(data ? data.seller : '', 7)
    }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {

    try {
      if (isInitialized) {
        setIsLoadingProfile(true)
        const params = { walletAddress: walletAddress || null };
        const profileDataResponse = await Moralis.Cloud.run("getCreatorDetailsByAddress", params);
        setProfileData(profileDataResponse)
        setIsLoadingProfile(false)
      }
    } catch (error) {
      setIsLoadingProfile(false)
      setProfileData({})
      console.error("MORALIS : error while fetching profile data ", error)

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInitialized])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    if (data.metadata) {
      const metadata = JSON.parse(data.metadata);
      let processedImageUrl = "";
      if (metadata.image && metadata.image.includes("ipfs://")) {
        const imageUrl = metadata.image.split("ipfs://");
        processedImageUrl = `https://hodl4gold.mypinata.cloud/ipfs/${imageUrl[1]}`;
      } else {
        processedImageUrl = metadata.image;
      }

      // get the file content type 
      const contentType = await getFileTypeFromURI(processedImageUrl)

      setNftContentType(contentType || '')
      setNftImage(processedImageUrl);
      setNftTitle(metadata.name || "~");
    } else {
      if (data.token_uri) {
        const response = await axios.get(data.token_uri);
        if (response.status === 200) {
          const metadata = response.data;
          let processedImageUrl = "";
          if (metadata.image && metadata.image.includes("ipfs://")) {
            const imageUrl = metadata.image.split("ipfs://");
            processedImageUrl = `https://hodl4gold.mypinata.cloud/ipfs/${imageUrl[1]}`;
          } else {
            processedImageUrl = metadata.image;
          }
          // get the file content type 
          const contentType = await getFileTypeFromURI(processedImageUrl)
          setNftContentType(contentType || '')
          setNftImage(processedImageUrl);
          setNftTitle(metadata.name || "~");
        }
      } else {
        setNftImage("");
        setNftTitle("~");
      }
    }
    console.log('nftImage cc', nftImage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="nft__item">
      {
        isLoadingProfile ?
          (
            <div className="de_countdown">
              <div className="spinner-grow spinner-grow-sm" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>

          ) :
          (
            <div className="de_countdown">

              <Link to={`/creator-profile/${profileData && profileData.attributes ? profileData.attributes.walletAddress : ''}`}>
                <span >{getUsername(profileData ? profileData.attributes : null)}</span>
              </Link>
            </div>
          )
      }

      <div className="nft-clickable-container">
        <Link to={`/sell-nft/${data.token_address}/token-id/${data.token_id}`}>
          <div className="author_list_pp">
            <span onClick={() => console.log("sell your nft")}>
              {getUserImage(sellerProfile?.attributes, 50)}
              <i className="fa fa-check"></i>
            </span>
          </div>
          <div className="nft__item_wrap" style={{ height: `${302}px` }}>
            <Outer>
              <span onClick={() => console.log("sell your nft")}>
                {
                  nftContentType.includes('audio') ? (
                    <div>
                      <audio controls autoplay>
                        <source src={nftImage} type={nftContentType} />
                      </audio>
                    </div>
                  ) : (<></>)
                }

                {
                  nftContentType.includes('image') ? (
                    <img src={nftImage} alt={nftTitle} className="lazy nft__item_preview" />
                  ) : (<></>)
                }
                {/* <img src={nftImage} className="lazy nft__item_preview" alt="" /> */}
              </span>
            </Outer>
          </div>
          <div className="nft__item_info">
            <span onClick={() => console.log("sell your nft")}>
              <h4>{getSliceLongTxt(nftTitle, 30)}</h4>
            </span>
            <div className="nft__item_price">
              Token ID : # {data.token_id || "~"}
            </div>
            <div className="nft__item_action sell-nft-btn">
              <span>Sell your NFT</span>
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
}
